import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, inject } from "vue";
import { IQuestion, ISurvey } from "@/domain/entities/survey/survey.types";
import { useSurveyStore } from "@/stores/surveyStore";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import FooterButton from "@/components/shared/button/FooterButton.vue";
import BaseTextarea from "@/components/shared/inputs/base/BaseTextarea.vue";
import { PROVIDE_KEY_SHOW_TOAST_MESSAGE, ShowToastMessage } from "@/types";


const __default__ = {
  name: "Opinion",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["onClickClose"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const surveyStore = useSurveyStore();

const complaintsSurvey = ref<ISurvey>();
const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;

const userAnswers = ref<Map<number, Map<string, string>>>(new Map());
const isComplete = computed(() => {
  const answerValues = [...userAnswers.value.values()];
  const selectedRadioValue = answerValues.find((answer) =>
    answer.get("selected")
  );
  const textareaValue = answerValues.find((answer) => answer.get("inputValue"));
  if (!selectedRadioValue) {
    return false;
  }
  if (
    selectedRadioValue.get("selected") === "ETC" &&
    !textareaValue?.get("inputValue")
  ) {
    return false;
  }
  return true;
});

const onClickRadioButton = (answerId: string, question: IQuestion) => {
  const map = new Map<string, string>();
  map.set("selected", answerId);
  userAnswers.value.set(question.order, map);
  const textArea = document.getElementById(`textArea${question.order + 1}`) as
    | HTMLTextAreaElement
    | undefined;
  if (!textArea) {
    return;
  }
  if (answerId === "ETC") {
    textArea.focus();
    return;
  }
  textArea.value = "";
  textArea.blur();
  updateTextAreaAnswer(question.order + 1, textArea.value);
};

const focusRadioInput = (questionOrder: number) => {
  const radioInput = document.getElementById(`radio${questionOrder - 1}`) as
    | HTMLInputElement
    | undefined;
  if (radioInput) {
    radioInput.checked = true;
    const map = new Map<string, string>();
    map.set("selected", radioInput.value);
    userAnswers.value.set(questionOrder - 1, map);
  }
};

const updateTextAreaAnswer = (questionOrder: number, textareaValue: string) => {
  const map = new Map<string, string>();
  map.set("inputValue", textareaValue);
  userAnswers.value.set(questionOrder, map);
};

const getRadioButtonId = (questionOrder: number, answerId: string) => {
  if (answerId !== "ETC") {
    return undefined;
  }
  return `radio${questionOrder}`;
};

const onClickFooterButton = async () => {
  if (!isComplete.value) {
    return;
  }
  userAnswers.value = new Map([...userAnswers.value.entries()].sort());
  // 실패해도 유저의 심기를 거스르지 않기 위해 의견 받은걸로 처리
  await surveyStore.sendSurveyResult(
    complaintsSurvey.value!.id,
    userAnswers.value
  );
  showToastMessage("소중한 의견 감사합니다", 3500, 0);
  emit("onClickClose");
};

const getTextAreaLength = (questionOrder: number) => {
  if (!userAnswers.value.get(questionOrder)) {
    return 0;
  }
  return userAnswers.value.get(questionOrder)!.get("inputValue")!.length;
};

const setupSurvey = () => {
  complaintsSurvey.value = surveyStore.complaintsSurvey;
  complaintsSurvey.value?.questions?.forEach((question) => {
    if (question.answerType === "text") {
      const map = new Map<string, string>();
      map.set("inputValue", "");
      userAnswers.value.set(question.order, map);
    }
  });
};

onMounted(() => {
  setupSurvey();
});

const __returned__ = { emit, surveyStore, complaintsSurvey, showToastMessage, userAnswers, isComplete, onClickRadioButton, focusRadioInput, updateTextAreaAnswer, getRadioButtonId, onClickFooterButton, getTextAreaLength, setupSurvey, NavigationBar, FooterButton, BaseTextarea }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})